import { render, staticRenderFns } from "./drugdata.vue?vue&type=template&id=91acdba4&"
import script from "./drugdata.vue?vue&type=script&lang=js&"
export * from "./drugdata.vue?vue&type=script&lang=js&"
import style0 from "./drugdata.vue?vue&type=style&index=0&id=91acdba4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports